<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <!-- <div class="item">
            <span class="label">{{ $t("g.create_at") }}</span>
            <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
              unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
              :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
            </el-date-picker>
          </div> -->
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
        <el-button type="primary" @click="func.newActivity('add')" class="btn-add">{{ $t('g.added') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" :stripe="true" style="width: 100%">
        <el-table-column prop="Id" label="ID">
        </el-table-column>
        <el-table-column prop="AgentName" label="分账方">
        </el-table-column>
        <el-table-column prop="RXAgentName" label="分账接收方">
        </el-table-column>
        <el-table-column prop="ShareRate" label="分账比例(%)">
        </el-table-column>
        <el-table-column prop="Times" label="分账接收次数">
        </el-table-column>
        <el-table-column prop="TotalNum" label="分账接收金额">
          <template #default="scope">
            <span>{{ (scope.row.TotalNum / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateAtStr" label="创建时间">
        </el-table-column>
        <el-table-column width="120" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.newActivity('edit', scope.row)" class="btn-edit" type="primary">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="formData.openType == 1 ? $t('g.added') : $t('g.edit')" v-model="formData.addElDailog" width="85%"
      center>
      <div class="dailog-content">
        <div class="activity-content">
          <el-form label-width="180px" :model="formData.profitInfo">
            <el-row>
              <el-col :span="8">
                <el-form-item label="分账方" prop="name">
                  <el-cascader style="width: 100%;flex: 1;" :clearable="true" :placeholder="$t('g.choose')"
                    v-model="formData.profitInfo.CodePathID" :props="formData.props"
                    :options="render.cascade_options_direct" :disabled="formData.openType == 2" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分账接收方" prop="name">
                  <el-cascader style="width: 100%;flex: 1;" :clearable="true" :placeholder="$t('g.choose')"
                    v-model="formData.profitInfo.RXCodePathID" :props="formData.props"
                    :options="render.cascade_options_direct" :disabled="formData.openType == 2" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分账接收方微信商户全称">
                  <el-input v-model="formData.profitInfo.WXAgentName" :disabled="formData.openType == 2" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select class="inp" v-model="formData.profitInfo.Status" :placeholder="$t('g.choose')"
                    style="width: 100%;" @change="func.HomeSelect">
                    <el-option label="开启" :value="1"></el-option>
                    <el-option label="关闭" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分账比例">
                  <el-input v-model="formData.profitInfo.ShareRate"
                    @input="formData.profitInfo.ShareRate = func.validateShareRate(formData.profitInfo.ShareRate)">
                    <template #append>%</template>
                  </el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <span style="margin-left: 180px;color: red;font-weight: bold;">（所有分账比例总和不能超过30%）</span>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="formData.addElDailog = false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="func.save">{{ $t('confirm') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { shortcuts, operators, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import axios from "axios"
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import cfg from '@/common/conf'
import { user, isOperator } from '@/data/token'
import i18n from '@/data/i18n/index'

export default {
  name: 'BillRefundRecord',
  setup() {
    const t = i18n.global.t
    const tableData = []
    const render = {
      devTypes: [
        {
          label: t("device.types.ebox"),
          value: 1
        },
        {
          label: t("device.types.cbox"),
          value: 2
        },
        {
          label: t("device.types.pile"),
          value: 3
        },
      ],
      operators,
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      openType: 1,
      addElDailog: false,
      tableData,
      Id: '',
      Mobile: '',
      rechargeType: false,
      devices: [],
      valAddDevType: 1,
      billData: {},
      valTime: '',
      curPage: 1,
      pageSize: 10,
      total: 0,
      valName: '',
      dialogVisible: false,
      CodePathID: 0,
      RXCodePathID: 0,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      profitInfo: {
        Status: 0,
        CodePathID: 0,
        RXCodePathID: 0,
        ShareRate: 0,
        WXAgentName: ''
      },
      ComboDays: 0
    })
    const func = {
      async expand(row, state) {
        if (state.length) {
        }
      },
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      validateShareRate(value) {
        if (!value) return '';
        if (value.length === 1) return value.replace(/[^0-9]/g, '');
        return value.replace(/^0|[^0-9]/g, '').slice(0, 2);
      },
      async save() {
        let params = JSON.parse(JSON.stringify(formData.profitInfo))
        if (params.ShareRate > 30) {
          ElMessage.error('分润比例不能超过30%')
          return
        }
        params.ShareRate = (params.ShareRate / 100).toFixed(2)
        if (formData.openType == 1) {
          let res = await axios.post("/admin/share/addrxagent", params)
          if (res == '添加成功') {
            ElMessage({
              type: 'success',
              message: '添加成功'
            })
            formData.addElDailog = false
            func.loadData()
          } else {
            ElMessage({
              type: 'error',
              message: '添加失败'
            })
          }
          console.log('添加结果', res)
        } else {
          delete params.CodePathID
          delete params.RXCodePathID
          delete params.WXAgentName
          let res = await axios.post("/admin/share/edit", params)
          if (res == '修改成功') {
            ElMessage({
              type: 'success',
              message: '修改成功'
            })
            func.loadData()
            formData.addElDailog = false
          } else {
            ElMessage({
              type: 'error',
              message: '修改失败'
            })
          }
          console.log('修改结果', res)
        }

      },
      async newActivity(type, row) {
        console.log(type, '参数')
        if (type == 'add') {
          formData.profitInfo = {
            Status: 0,
            CodePathID: 0,
            RXCodePathID: 0,
            ShareRate: 0,
            WXAgentName: ''
          }
          formData.openType = 1
        } else {
          formData.profitInfo = {
            Status: row.Status,
            CodePathID: row.CodePathID,
            RXCodePathID: row.RXCodePathID,
            WXAgentName: row.WXAgentName,
            ShareRate: row.ShareRate,
            Id: row.Id
          }
          formData.openType = 2
        }
        formData.addElDailog = true

      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          // if (formData.valDevNo) {
          //   params.dev_id = formData.valDevNo
          // }
          // if (formData.valTime) {
          //   params.startAt = Math.floor(Date.parse(formData.valTime[0]+ " 00:00:00") / 1000)
          //   params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          // }
          let res = await axios.get(`/admin/share/getshareconf`, {
            params
          })
          console.log(res, '数据111')
          formData.total = res.Total
          res.List.map((item) => {
            if (item.CreateAt) {
              item.CreateAtStr = toDay(item.CreateAt)
            } else {
              item.CreateAtStr = '--'
            }
            item.ShareRate = (item.ShareRate * 100).toFixed(0)
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
      console.log('1212121', cascade_options_direct)
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  .table-detail {
    display: flex;
    flex-direction: column;
    margin-right: 9.375rem;
    padding-left: 4rem;
    padding-top: 1rem;

    .orders {
      .order {
        display: flex;
        margin-bottom: 0.5rem;
        align-items: center;

        >div {
          margin-right: 1rem;
        }
      }
    }

    >.item {
      margin-right: 0.625rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.625rem;
      color: #333333;

      >img {
        margin-left: 0.625rem;
        width: 4rem;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .boximg {
    width: 4rem;
    height: 3rem;
    object-fit: cover;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;

        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 88%;
      margin: 0 auto;
    }

    &.line-3 {
      :deep(.el-form-item) {
        width: 33%;
      }
    }

    .inp {
      width: 100%;
    }

    .avatar-uploader {
      :deep(.el-upload) {
        border: 1px dashed #d9d9d9;
        border-radius: 0.375rem;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409eff;
        }
      }
    }

    .avatar-uploader-icon {
      font-size: 1.75rem;
      color: #8c939d;
      width: 11rem;
      height: 9rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .avatar {
      width: 11rem;
      height: 9rem;
      display: block;
      object-fit: cover;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  .userInfo {
    margin-top: 15px;
    text-align: left;
    font-weight: bold;
    font-size: 18px;
  }
}
</style>